import axios from 'axios';
import { Apis } from 'constants/apis';
import { getToken } from 'utils/token';

const createFaq = async (payload: any) => {
    const { data } = await axios.post(Apis.CREATE_FAQS, payload, { headers: { Authorization: getToken() } });
    return data;
};

export default createFaq;
